function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.543,19.833h8.52v-8.52Zm0,0",
  transform: "translate(-10.14 -9.909)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M.23,51.975H31.5L21.817,41.415l0-.009a1.049,1.049,0,0,1-.189-.308c-.013-.03-.021-.059-.031-.088a1.222,1.222,0,0,1-.041-.117l-2.1-9.962a1.151,1.151,0,0,1,.265-1.01.939.939,0,0,1,.926-.289l9.13,2.3a1.031,1.031,0,0,1,.106.044c.028.011.054.021.082.034a.989.989,0,0,1,.28.2l.011.007,9.677,10.567V0H12.138V11.911a1.041,1.041,0,0,1-.992,1.083H.23Zm6.946-34.65h25.8a1.087,1.087,0,0,1,0,2.166H7.177a1.087,1.087,0,0,1,0-2.166Zm0,6.5h25.8a1.087,1.087,0,0,1,0,2.166H7.177a1.087,1.087,0,0,1,0-2.166Zm0,6.5h6.946a1.087,1.087,0,0,1,0,2.166H7.177a1.087,1.087,0,0,1,0-2.166Zm0,0",
  transform: "translate(-0.23)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M179.453,238.735l-5.839-1.345,1.346,5.838Zm0,0",
  transform: "translate(-150.506 -205.356)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M212.288,270.439l-15.436-15.447-5.622,5.623,15.446,15.437Zm0,0",
  transform: "translate(-164.452 -219.019)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M332.658,396.44a3.956,3.956,0,0,0,.009-5.608l-5.145,5.144-.467.468a3.954,3.954,0,0,0,5.6,0Zm0,0",
  transform: "translate(-283.429 -338.01)"
});

function SvgHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50.4,
    height: 59.599,
    viewBox: "0 0 50.4 59.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/historyIcon.cdba9711.svg";
export { ForwardRef as ReactComponent };